export const LOGOS = {
  BRAND: {
    LIGHT: {
      icon: "/images/logos/antos/icon.png",
      small: "/images/logos/Plus100.png",
      medium: "/images/logos/Plus100.png",
      large: "/images/logos/Plus100.png",
    },
    DARK: {
      icon: "/images/logos/antos/icon.png",
      small: "/images/logos/Plus100.png",
      medium: "/images/logos/Plus100.png",
      large: "/images/logos/Plus100.png",
    },
  },
  BROKER1: {
    LIGHT: {
      icon: "/images/logos/antos/icon.png",
      small: "/images/logos/antos/icon.png",
      medium: "/images/logos/antos/icon.png",
      large: "/images/logos/antos/icon.png",
    },
    DARK: {
      icon: "/images/logos/antos/icon.png",
      small: "/images/logos/Plus100.png",
      medium: "/images/logos/Plus100.png",
      large: "/images/logos/Plus100.png",
    },
  },
  BROKER2: {
    LIGHT: {
      icon: "",
      small: "",
      medium: "",
      large: "",
    },
    DARK: {
      icon: "",
      small: "",
      medium: "",
      large: "",
    },
  },
};
export const CURRENT_BROKER = "LEVEL2";
export const CURRENT_BROKER_NAME = "app";
export const CURRENT_BROKER_ID = "4";
export const CURRENT_SERVER_NAME = "Alpaca";
export const CURRENT_DEFAULT_SYMBOL = "NVDA";
export const enableVideoTutorial = true;
export const isMT5 = false;
export const BUILD_CANVAS_STRATEGY = "d87cbf34-dae1-47a0-aff8-c4ba03cfedba";

export const BROKER_LOGO = {
  ALPACA: {
    LIGHT: {
      icon: "/images/logos/alpaca/icon.png",
      small: "/images/logos/alpaca/logo-dark.svg",
      medium: "/images/logos/alpaca/logo-dark.svg",
      large: "/images/logos/alpaca/logo-dark.svg",
      favicon: "/favicons/antos/favicon.ico",
      textLogo: "/images/logos/alpaca/alpaca-logo-dark.png",
      logo: "/images/logos/alpaca/icon.svg",
    },
    DARK: {
      icon: "/images/logos/alpaca/icon.png",
      small: "/images/logos/alpaca/logo-light.svg",
      medium: "/images/logos/alpaca/logo-light.svg",
      large: "/images/logos/alpaca/logo-light.svg",
      favicon: "/favicons/antos/favicon.ico",
      textLogo: "/images/logos/alpaca/alpaca-logo-dark.png",
      logo: "/images/logos/alpaca/icon.svg",
    },
  },
  ANTOS: {
    LIGHT: {
      icon: "/images/logos/antos/icon.png",
      small: "/images/logos/antos/icon.png",
      medium: "/images/logos/antos/icon.png",
      large: "/images/logos/antos/icon.png",
      favicon: "/favicons/antos/favicon.ico",
      textLogo: "/images/logos/antos/Lightspeed.png",
    },
    DARK: {
      icon: "/images/logos/antos/icon.png",
      small: "/images/logos/antos/icon.png",
      medium: "/images/logos/antos/icon.png",
      large: "/images/logos/antos/icon.png",
      favicon: "/favicons/antos/favicon.ico",
      textLogo: "/images/logos/antos/Lightspeed.png",
    },
  },
  SPARK: {
    LIGHT: {
      icon: "/images/logos/spark/apple-touch-icon.png",
      small: "/images/logos/spark/apple-touch-icon.png",
      medium: "/images/logos/spark/apple-touch-icon.png",
      large: "/images/logos/spark/Sparkmarkets_favicon-16x16.png",
      favicon: "/images/logos/spark/Sparkmarkets_favicon-16x16.png.png",
      textLogo: "/images/logos/spark/spark_text.svg",
    },
    DARK: {
      icon: "/images/logos/spark/apple-touch-icon.png",
      small: "/images/logos/spark/apple-touch-icon.png",
      medium: "/images/logos/spark/apple-touch-icon.png",
      large: "/images/logos/spark/Sparkmarkets_favicon-16x16.png",
      favicon: "/images/logos/spark/Sparkmarkets_favicon-16x16.png.png",
      textLogo: "/images/logos/spark/spark_text.svg",
    },
  },
  LIGHTSPEED: {
    LIGHT: {
      icon: "/images/logos/lightspeed/logo-dark.svg",
      small: "/images/logos/lightspeed/logo-dark.svg",
      medium: "/images/logos/lightspeed/logo-dark.svg",
      large: "/images/logos/lightspeed/logo-dark.svg",
      favicon: "/images/logos/lightspeed/logo-dark.svg",
      textLogo: "/images/logos/lightspeed/logo-dark.svg",
      logo: "/images/logos/lightspeed/icon.svg",
    },

    DARK: {
      icon: "/images/logos/lightspeed/logo-light.svg",
      small: "/images/logos/lightspeed/logo-light.svg",
      medium: "/images/logos/lightspeed/logo-light.svg",
      large: "/images/logos/lightspeed/logo-light.svg",
      favicon: "/images/logos/lightspeed/logo-light.svg",
      textLogo: "/images/logos/lightspeed/logo-light.svg",
      logo: "/images/logos/lightspeed/icon.svg",
    },
  },
  MATCHTRADE: {
    LIGHT: {
      icon: "/images/logos/matchtrade/icon.png",
      small: "/images/logos/matchtrade/icon.png",
      medium: "/images/logos/matchtrade/icon.png",
      large: "/images/logos/matchtrade/icon.png",
      favicon: "/images/logos/matchtrade/icon.png",
      textLogo: "/images/logos/matchtrade/text-logo.png",
      logo: "/images/logos/matchtrade/icon.svg",
    },

    DARK: {
      icon: "/images/logos/matchtrade/icon.png",
      small: "/images/logos/matchtrade/icon.png",
      medium: "/images/logos/matchtrade/icon.png",
      large: "/images/logos/matchtrade/icon.png",
      favicon: "/images/logos/matchtrade/icon.png",
      textLogo: "/images/logos/matchtrade/text-logo.png",
      logo: "/images/logos/matchtrade/icon.svg",
    },
  },
  CTRADER: {
    LIGHT: {
      icon: "/images/logos/ctrader/text-logo.svg",
      small: "/images/logos/ctrader/text-logo.svg",
      medium: "/images/logos/ctrader/text-logo.svg",
      large: "/images/logos/ctrader/text-logo.svg",
      favicon: "/images/logos/ctrader/text-logo.svg",
      textLogo: "/images/logos/ctrader/text-logo.svg",
      logo: "/images/logos/ctrader/icon.svg",
    },

    DARK: {
      icon: "/images/logos/ctrader/text-logo.svg",
      small: "/images/logos/ctrader/text-logo.svg",
      medium: "/images/logos/ctrader/text-logo.svg",
      large: "/images/logos/ctrader/text-logo.svg",
      favicon: "/images/logos/ctrader/text-logo.svg",
      textLogo: "/images/logos/ctrader/text-logo.svg",
      logo: "/images/logos/ctrader/icon.svg",
    },
  },
  MT5: {
    LIGHT: {
      icon: "/images/logos/mt-5/mtg-white.png",
    },

    DARK: {
      icon: "/images/logos/mt-5/mtg-white.png",
    },
  },
  FUNDORA: {
    LIGHT: {
      icon: "/images/logos/fundora/logo.svg",
    },

    DARK: {
      icon: "/images/logos/fundora/logo.svg",
    },
  },
  TRADEZERO: {
    LIGHT: {
      icon: "/images/logos/trade-zero/logo.png",
      small: "/images/logos/trade-zero/logo.png",
      medium: "/images/logos/trade-zero/logo.png",
      large: "/images/logos/trade-zero/logo.png",
      favicon: "/images/logos/trade-zero/logo.png",
      textLogo: "/images/logos/trade-zero/text-logo.svg",
      logo: "/images/logos/trade-zero/icon.svg",
    },

    DARK: {
      icon: "/images/logos/trade-zero/logo.png",
      small: "/images/logos/trade-zero/logo.png",
      medium: "/images/logos/trade-zero/logo.png",
      large: "/images/logos/trade-zero/logo.png",
      favicon: "/images/logos/trade-zero/logo.png",
      textLogo: "/images/logos/trade-zero/text-logo.svg",
      logo: "/images/logos/trade-zero/icon.svg",
    },
  },
  TRADESTATION: {
    LIGHT: {
      icon: "/images/logos/trade-station/logo.png",
      small: "/images/logos/trade-station/logo.png",
      medium: "/images/logos/trade-station/logo.png",
      large: "/images/logos/trade-station/logo.png",
      favicon: "/images/logos/trade-station/logo.png",
      textLogo: "/images/logos/trade-station/text-logo.svg",
      logo: "/images/logos/trade-station/icon.svg",
    },

    DARK: {
      icon: "/images/logos/trade-station/logo.png",
      small: "/images/logos/trade-station/logo.png",
      medium: "/images/logos/trade-station/logo.png",
      large: "/images/logos/trade-station/logo.png",
      favicon: "/images/logos/trade-station/logo.png",
      textLogo: "/images/logos/trade-station/text-logo.svg",
      logo: "/images/logos/trade-station/icon.svg",
    },
  },
  PUBLIC: {
    LIGHT: {
      icon: "/images/logos/public/public-text-logo.svg",
      small: "/images/logos/public/public-text-logo.svg",
      medium: "/images/logos/public/public-text-logo.svg",
      large: "/images/logos/public/public-text-logo.svg",
      favicon: "/images/logos/public/public-text-logo.svg",
      textLogo: "/images/logos/public/public-text-logo.svg",
      logo: "/images/logos/public/public-text-logo.svg",
    },

    DARK: {
      icon: "/images/logos/public/public-text-logo.svg",
      small: "/images/logos/public/public-text-logo.svg",
      medium: "/images/logos/public/public-text-logo.svg",
      large: "/images/logos/public/public-text-logo.svg",
      favicon: "/images/logos/public/public-text-logo.svg",
      textLogo: "/images/logos/public/public-text-logo.svg",
      logo: "/images/logos/public/public-icon.svg",
    },
  },
  FENNEL: {
    LIGHT: {
      icon: "/images/logos/fennel/icon.png",
      small: "/images/logos/fennel/logo-light.svg",
      medium: "/images/logos/fennel/logo-light.svg",
      large: "/images/logos/fennel/logo-light.svg",
      favicon: "/images/logos/fennel/logo-light.svg",
      textLogo: "/images/logos/fennel/fennel-logo-dark.png",
      logo: "/images/logos/fennel/icon.svg",
    },

    DARK: {
      icon: "/images/logos/fennel/icon.png",
      small: "/images/logos/fennel/logo-light.svg",
      medium: "/images/logos/fennel/logo-light.svg",
      large: "/images/logos/fennel/logo-light.svg",
      favicon: "/images/logos/fennel/logo-light.svg",
      textLogo: "/images/logos/fennel/fennel-logo-dark.png",
      logo: "/images/logos/fennel/icon.svg",
    },
  },
  LEVERATE: {
    LIGHT: {
      icon: "/images/logos/leverate/leverate-icon.png",
      small: "/images/logos/leverate/leverate-icon.png",
      medium: "/images/logos/leverate/leverate-icon.png",
      large: "/images/logos/leverate/leverate-icon.png",
      favicon: "/images/logos/leverate/leverate-icon.png",
      textLogo: "/images/logos/leverate/leverate-icon.png",
      logo: "/images/logos/leverate/icon.svg",
    },

    DARK: {
      icon: "/images/logos/leverate/leverate-icon.png",
      small: "/images/logos/leverate/leverate-icon.png",
      medium: "/images/logos/leverate/leverate-icon.png",
      large: "/images/logos/leverate/leverate-icon.png",
      favicon: "/images/logos/leverate/leverate-icon.png",
      textLogo: "/images/logos/leverate/leverate-icon.png",
      logo: "/images/logos/leverate/icon.svg",
    },
  },
  WEBBULLS: {
    LIGHT: {
      icon: "/images/logos/webbulls/text-logo.svg",
      small: "/images/logos/webbulls/text-logo.svg",
      medium: "/images/logos/webbulls/text-logo.svg",
      large: "/images/logos/webbulls/text-logo.svg",
      favicon: "/images/logos/webbulls/text-logo.svg",
      textLogo: "/images/logos/webbulls/text-logo.svg",
      logo: "/images/logos/webbulls/text-logo.svg",
    },

    DARK: {
      icon: "/images/logos/webbulls/text-logo.svg",
      small: "/images/logos/webbulls/text-logo.svg",
      medium: "/images/logos/webbulls/text-logo.svg",
      large: "/images/logos/webbulls/text-logo.svg",
      favicon: "/images/logos/webbulls/text-logo.svg",
      textLogo: "/images/logos/webbulls/text-logo.svg",
      logo: "/images/logos/webbulls/text-logo.svg",
    },
  },
};
